import { request } from '@/utils/request'
import { refresh as refreshJwt } from '@/utils/jwt.js'

export default {
    async login(username, password) {
        const response = await request.post('/api/auth/login', { username, password })
        refreshJwt()
        return response
    },
    async logout() {
        const response = await request.post('/api/auth/logout', {})
        refreshJwt()
        return response
    },
    beginAccountRecovery(emailAddress) {
        return request.post('/api/auth/recovery', { emailAddress })
    },
    async finishAccountRecovery(token, password) {
        const response = await request.put(`/api/auth/recovery/${token}`, { password })
        refreshJwt()
        return response
    },
    validateToken(token) {
        return request(`/api/auth/recovery/${token}`)
    },
    async changePassword(currentPassword, newPassword) {
        const response = await request.post('/api/auth/password', {
            currentPassword: currentPassword,
            newPassword: newPassword,
        })
        refreshJwt()
        return response
    },
}
